import { isExistingSystem, isSimpleEstimateExistingSystem } from 'projectSections/sections/energy/Retrofit/utils'
import { StudioSystemType } from 'types/global'
import { RetrofitSystemDesignChoiceEnum } from 'types/studio/items'
import { SystemDesignComponentDetailSnapshot } from '../reconciler/systemDesignComponentDetailSnapshot'
import SystemHardwareReconciler from '../reconciler/systemHardwareReconciler'
import type { HardwareDetailType } from '../types'

const DEFAULT_OPTIONS: OptionsConfigType = {
  ignoreExistingSystemHardware: true,
  ignoreNegativeOrZero: true,
}

type OptionsConfigType = {
  ignoreExistingSystemHardware: boolean
  ignoreNegativeOrZero: boolean
}

const getHardwareDetailFromSystem = ({
  system,
  referenceSystem,
  options = DEFAULT_OPTIONS,
}: {
  system: StudioSystemType
  referenceSystem?: StudioSystemType
  options?: OptionsConfigType
}): HardwareDetailType[] => {
  if (isExistingSystem(system) && options.ignoreExistingSystemHardware) {
    return []
  }
  if (isSimpleEstimateExistingSystem(system)) {
    // simple estimate system data not reliable
    return []
  }

  if (referenceSystem !== undefined && isExistingSystem(referenceSystem)) {
    if (isSimpleEstimateExistingSystem(referenceSystem)) {
      // simple estimate system data not reliable
      return new SystemDesignComponentDetailSnapshot(system).allSystemHardware
    }

    // For legacy retrofit project, system doesn't have retrofit_system_design_choice but it treats as combined
    if (
      system.retrofit_system_design_choice === RetrofitSystemDesignChoiceEnum.COMBINED ||
      system.retrofit_system_design_choice === undefined
    ) {
      const hardwareDetailsDelta = SystemHardwareReconciler.getReconciliatedComponentDetailsBySystems({
        system,
        referenceSystem,
        mode: 'diff',
      })
      if (options.ignoreNegativeOrZero) {
        return hardwareDetailsDelta.filter((item) => item.quantity > 0)
      }
      return hardwareDetailsDelta
    }

    return new SystemDesignComponentDetailSnapshot(system).allSystemHardware
  }

  return new SystemDesignComponentDetailSnapshot(system).allSystemHardware
}

export default getHardwareDetailFromSystem
